export default __webpack_public_path__ + "land-use-plan-500-6ce78142586eae68bb31806b02e3521b.png";